import { ActionType, createAsyncAction } from 'typesafe-actions'
import { Failure, Request, Success } from './types'
import { CompanyState } from '../../types'

export const fetchCategoriesByCompanyAction = createAsyncAction(
  '@company/FETCH_CATEGORIES_BY_COMPANY_REQUEST',
  '@company/FETCH_CATEGORIES_BY_COMPANY_SUCCESS',
  '@company/FETCH_CATEGORIES_BY_COMPANY_FAILURE'
)<Request, Success, Failure>()

const request = (state: CompanyState): CompanyState => ({
  ...state,
  isLoadingFetchCategoriesByCompany: true,
  isErrorOnLoadingFetchCategoriesByCompany: false,
  isSuccessOnLoadingFetchCategoriesByCompany: false
})

const success = (
  state: CompanyState,
  action: ActionType<typeof fetchCategoriesByCompanyAction.success>
): CompanyState => ({
  ...state,
  isLoadingFetchCategoriesByCompany: false,
  isErrorOnLoadingFetchCategoriesByCompany: false,
  isSuccessOnLoadingFetchCategoriesByCompany: true,
  categories: action.payload.categories
})

const failure = (state: CompanyState): CompanyState => ({
  ...state,
  isLoadingFetchCategoriesByCompany: false,
  isSuccessOnLoadingFetchCategoriesByCompany: false,
  isErrorOnLoadingFetchCategoriesByCompany: true
})

export const fetchCategoriesByCompanyHandle = { asyncAction: fetchCategoriesByCompanyAction, request, success, failure }
